import { useAsyncFn } from 'react-use';

import GetLicenseInfo from './api';
import { TResponseGetLicenseInfo } from './type';
import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';

export type TUseGetLicenseInfo = {
  isLoading: boolean;
  response?: TResponseGetLicenseInfo;
  handleGetLicenseInfo: () => Promise<TResponseGetLicenseInfo | undefined>;
};

const useGetLicenseInfo = (): TUseGetLicenseInfo => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async () => {
    const response: Promise<TResponseGetLicenseInfo> = commonActionFromDALV2(GetLicenseInfo);
    const result = await response;
    return result;
  }, []);

  return {
    response: state?.value,
    handleGetLicenseInfo: doFetch,
    isLoading: state.loading,
  };
};

export default useGetLicenseInfo;
